import { mergeDeepRight } from 'ramda';
import { default_settings } from './default_settings.js';
import { local_settings } from './local_settings.js';

/* to switch to local server (while running freedom-server)
   change all 9000 ports in environments const from 'beta' to 'local' eg:

 'localhost:9000': 'local',
 '127.0.0.1:9000': 'local',
 '0.0.0.0:9000': 'local',

*/

const environments = {
  'localhost:8090': 'local',
  '127.0.0.1:8090': 'local',
  '0.0.0.0:8090': 'local0',

  'localhost:9000': 'local',
  '127.0.0.1:9000': 'local',
  '0.0.0.0:9000': 'local0',

  'client-beta.workpilots.com': 'beta',
  'freedom-beta.workpilots.com': 'beta',
  'lowo-beta.workpilots.com': 'beta',
  'wp-logistics-beta.workpilots.com': 'beta',
};

const get_environment = () => {
  let key = 'local';

  if (typeof window !== 'undefined') {
    const host = window.location.host;
    if (host in environments) {
      key = environments[host];
    } else if (host.endsWith('ngrok.io')) {
      key = 'local';
    } else {
      key = 'production';
    }
  }

  return key;
};

let current_env_key = get_environment();

let overrides = local_settings[current_env_key];

const settings = mergeDeepRight(default_settings, overrides);

export default settings;
